var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.5,
    height: 40.73,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 25.5 40.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 17.03,
    cy: 10.66,
    fx: 1.36,
    fy: 10.66,
    r: 16.06,
    gradientTransform: "translate(30.82 -7.71) rotate(84.75) scale(1 1.45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b6d900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#8ca700"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75,39.76C11.1,37,.5,19.01.5,12.75.5,6,6,.5,12.75.5s12.25,5.5,12.25,12.25c0,6.26-10.6,24.25-12.25,27.01ZM12.92,8.39c-2.23,0-4.05,1.82-4.05,4.05s1.82,4.05,4.05,4.05,4.05-1.82,4.05-4.05-1.82-4.05-4.05-4.05Z",
    fill: "url(#b)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75.75c6.62,0,12,5.38,12,12,0,5.97-9.81,22.84-12,26.53C10.56,35.59.75,18.72.75,12.75.75,6.13,6.13.75,12.75.75M12.92,16.75c2.37,0,4.3-1.93,4.3-4.3s-1.93-4.3-4.3-4.3-4.3,1.93-4.3,4.3,1.93,4.3,4.3,4.3M12.75.25C5.85.25.25,5.85.25,12.75s12.5,27.5,12.5,27.5c0,0,12.5-20.6,12.5-27.5S19.65.25,12.75.25h0ZM12.92,16.25c-2.1,0-3.8-1.7-3.8-3.8s1.7-3.8,3.8-3.8,3.8,1.7,3.8,3.8-1.7,3.8-3.8,3.8h0Z",
    fill: "#8ca700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerIcon);
export default __webpack_public_path__ + "static/media/marker-icon.bbeb6367bff8a32a52bd3794ae0ccff3.svg";
export { ForwardRef as ReactComponent };